var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('column-chart',{staticClass:"p-4",staticStyle:{"width":"90%"},attrs:{"data":_vm.chartData.data,"ytitle":_vm.chartData.yTitle,"xtitle":_vm.chartData.xTitle,"height":'400px',"loading":"Đang tải...","download":true,"thousands":","}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }